import type { Tutorial } from '../../shared/types.js';
import { claudeMaxTutorial } from './claude-max.js';
import { introTutorial } from './intro.js';
import { launchAgentTutorial } from './launch-agent.js';
import { connectGithubTutorial } from './connect-github.js';
import { connectSlackTutorial } from './connect-slack.js';
import { securityReviewFlowTutorial } from './security-review-flow.js';
import { githubPrFlowTutorial } from './github-pr-flow.js';
import { blueprintsTutorial } from './blueprints.js';
import { blueprintsOverviewTutorial } from './blueprints-overview.js';
import { baseBlueprintsTutorial } from './base-blueprints.js';
import { agentsTutorial } from './agents.js';
import { mcpServersTutorial } from './mcp-servers.js';
import { addMcpServerTutorial } from './add-mcp-server.js';
import { personasTutorial } from './personas.js';
import { organizationTutorial } from './organization.js';
import { membersTutorial } from './members.js';
import { orgModelProvidersTutorial } from './org-model-providers.js';
import { agentDetailTutorial } from './agent-detail.js';
import { sandboxMonitorTutorial } from './sandbox-monitor.js';

const ALL_TUTORIALS: readonly Tutorial[] = [
  claudeMaxTutorial,
  introTutorial,
  agentsTutorial,
  launchAgentTutorial,
  connectGithubTutorial,
  connectSlackTutorial,
  securityReviewFlowTutorial,
  githubPrFlowTutorial,
  blueprintsOverviewTutorial,
  blueprintsTutorial,
  baseBlueprintsTutorial,
  mcpServersTutorial,
  addMcpServerTutorial,
  personasTutorial,
  organizationTutorial,
  membersTutorial,
  orgModelProvidersTutorial,
  agentDetailTutorial,
  sandboxMonitorTutorial,
];

export const TUTORIALS: Record<string, Tutorial> = Object.fromEntries(
  ALL_TUTORIALS.map((t) => [t.name, t]),
);

export function getTutorial(name: string): Tutorial | null {
  return TUTORIALS[name] ?? null;
}

/**
 * Every tutorial featured on the doc page with this slug, in registration
 * order (which becomes the display order in the docs "Guided tutorials"
 * section). Returns an empty array when no tutorial maps to the slug, so the
 * docs section can simply render nothing.
 */
export function getTutorialsForDocPage(slug: string): Tutorial[] {
  return ALL_TUTORIALS.filter((t) => t.docPages?.includes(slug));
}
